import { BASE_URL } from "../urls";
import { syncAuthError } from "./sync";
export const answerEndpoint = responseID =>
  `${BASE_URL}/responses/${responseID}/answers`;
const userEditsEndpoint = responseID =>
  `${BASE_URL}/responses/${responseID}/userEdits`;
const metadataEndpoint = responseID =>
  `${BASE_URL}/responses/${responseID}/metadata`;

export const TOGGLE_QUESTION_FLAGGED = "TOGGLE_QUESTION_FLAGGED";
export function toggleQuestionFlagged(id, response, section) {
  return {
    type: TOGGLE_QUESTION_FLAGGED,
    id: id,
    response,
    section
  };
}

export const SAVE_ANSWER_NOTE = "SAVE_ANSWER_NOTE";
export function saveAnswerNote(id, value, response) {
  if (!response) {
    throw new Error("Called without response argument");
  }
  return {
    type: SAVE_ANSWER_NOTE,
    question: id,
    note: value,
    response
  };
}

export const SAVE_ANSWER = "SAVE_ANSWER";
export function saveAnswer(id, value, section, response) {
  if (!response) {
    throw new Error("Called without response argument");
  }
  return {
    type: SAVE_ANSWER,
    question: id,
    answer: value,
    section: section,
    response
  };
}

// export function postAnswer(id) {
//   return (dispatch, getState) => {
//     const state = getState();
//     const response = state.responses.items.find(
//       r => r.metadata.id === state.responses.responseID
//     );
//     if (response) {
//       const answer = response.answers[id];
//       dispatch(postingAnswer());
//       return fetch(answerEndpoint(response.metadata.id), {
//         method: "POST",
//         compress: false,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           Authorization: state.auth.token
//         },
//         body: JSON.stringify({
//           ...answer,
//           question: id
//         })
//       })
//         .then(res => {
//           if (!res.ok) {
//             if (res.status === 401 || res.status === 403) {
//               dispatch(syncAuthError("Your session has expired"));
//             } else {
//               throw new Error("Problem saving answer");
//             }
//           } else {
//             dispatch(postedAnswer());
//           }
//         })
//         .catch(e => {
//           console.log(e);
//           // dispatch(syncError("Error pushing local changes"));
//         });
//     } else {
//       dispatch(postingAnswer());
//       dispatch(postedAnswer());
//     }
//   };
// }

// export const SYNCING_ANSWERS = "SYNCING_ANSWERS";

// export const syncAnswers = () => {
//   return (dispatch, getState) => {
//     // get answers that need syncing
//     var questionIDs = getState()
//       .sync.answersToSync.filter((x, i, a) => a.indexOf(x) == i);
//     if (questionIDs.length) {
//       questionIDs.forEach(id => dispatch(postAnswer(id)));
//       dispatch({ type: SYNCING_ANSWERS, ids: questionIDs });
//     }
//   };
// };

export const SYNCING_USER_EDITS = "SYNCING_USER_EDITS";
export const syncUserEdits = () => {
  return (dispatch, getState) => {
    if (getState().sync.plzSyncUserEdits) {
      dispatch({ type: SYNCING_USER_EDITS });
      const state = getState();
      const response = state.responses.items.find(
        r => r.metadata.id === state.responses.responseID
      );
      return fetch(userEditsEndpoint(response.metadata.id), {
        method: "POST",
        compress: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: state.auth.token
        },
        body: JSON.stringify(response.userEdits)
      })
        .then(res => {
          if (!res.ok) {
            if (res.status === 401 || res.status === 403) {
              dispatch(syncAuthError("Your session has expired"));
            } else {
              throw new Error("Problem saving answer");
            }
          }
        })
        .catch(e => {
          console.log(e);
          // dispatch(syncError("Error pushing local changes"));
        });
    }
  };
};

export const POSTING_ANSWER = "POSTING_ANSWER";
export const postingAnswer = () => ({
  type: POSTING_ANSWER
});

export const POSTED_ANSWER = "POSTED_ANSWER";
export const postedAnswer = () => ({
  type: POSTED_ANSWER
});

export const CLEAR_RESPONSE = "CLEAR_RESPONSE";
export function clearResponse(response) {
  return {
    type: CLEAR_RESPONSE,
    response
  };
}

export const LOAD_RESPONSE_DATA = "LOAD_RESPONSE_DATA";
export function loadResponseData(payload, secretKey = null) {
  return {
    type: LOAD_RESPONSE_DATA,
    payload,
    secretKey
  };
}

export const UPDATE_FISHERY_METADATA = "UPDATE_FISHERY_METADATA";
export function updateFisheryMetadata(attributes, responseID) {
  return (dispatch, getState) => {
    const state = getState();
    fetch(metadataEndpoint(responseID), {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
          "Content-Type": "application/json",
          Authorization: state.auth.token,
      },
      body: JSON.stringify(attributes)
    }).then(() => {
      dispatch({
        type: UPDATE_FISHERY_METADATA,
        attributes,
        responseID
      })
    });
  }
}
